import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

export interface SetInfo {
  code: string;
  name: string;
  cardCount: number;
  iconUrl: string | null;
  releasedAt: string | null;
  setType: string | null;
}

export interface SetsResponse {
  sets: SetInfo[];
  totalCount: number;
  hasMore: boolean;
}

export const setsApi = createApi({
  reducerPath: 'setsApi',
  baseQuery: baseQuery,
  tagTypes: ['Sets'],
  endpoints: (builder) => ({
    getSets: builder.query<SetsResponse, { search?: string; limit?: number; offset?: number }>({
      query: ({ search, limit = 50, offset = 0 }) => {
        const params = new URLSearchParams({
          limit: limit.toString(),
          offset: offset.toString()
        });
        if (search) params.append('search', search);
        return {
          url: `/sets?${params.toString()}`,
          method: 'GET',
          requiresAuth: true,
        };
      },
      providesTags: ['Sets'],
    }),
  }),
});

export const { useGetSetsQuery, useLazyGetSetsQuery } = setsApi;
